import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router'

const SCOPE_KEYS = {
  siteId: 'siteID',
  assetId: 'assetID'
}

function readParam (searchParams, key) {
  return searchParams.get(key) || null
}

export function useUrlAssetScope () {
  const [searchParams, setSearchParams] = useSearchParams()

  const scope = useMemo(
    () => ({
      siteId: readParam(searchParams, SCOPE_KEYS.siteId),
      assetId: readParam(searchParams, SCOPE_KEYS.assetId)
    }),
    [searchParams]
  )

  const setScope = useCallback(
    (changes, { replace = false } = {}) => {
      setSearchParams(
        previous => {
          const next = new URLSearchParams(previous)

          Object.entries(changes).forEach(([property, value]) => {
            const paramName = SCOPE_KEYS[property]

            if (!paramName) {
              throw new Error(`Unsupported URL scope property: ${property}`)
            }

            if (value === null || value === undefined || value === '') {
              next.delete(paramName)
            } else {
              next.set(paramName, String(value))
            }
          })

          return next
        },
        { replace }
      )
    },
    [setSearchParams]
  )

  const clearScope = useCallback(() => {
    setScope({
      siteId: null,
      assetId: null
    })
  }, [setScope])

  return {
    ...scope,
    setScope,
    clearScope
  }
}
